<template>
    <AnsWidget
        v-if="isWidgetVisible"
        :is-visible="isWidgetVisible"
        :show-content="showContent"
        :position="widgetConfig.position"
        :is-mobile="widgetConfig.isMobile"
        :icon-props="widgetConfig.iconProps"
        :show-close-button="widgetConfig.showCloseButton"
        :show-icon-toggle="widgetConfig.showIconToggle"
        :styles="widgetConfig.styles"
        :classes="widgetConfig.classes"
        :offset="widgetConfig.offset"
        :draggable="widgetConfig.draggable"
        @icon-click="handleIconClick"
        @close="handleClose"
    >
        <component :is="widgetComponent" v-bind="componentProps" @close="handleComponentClose" />
    </AnsWidget>
</template>

<script>
/**
 * ****************************************************************************
 * @description     :   Global Widget Component
 * @created at      :   2025/08/19
 * @created by      :   DaoNX
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import { mapMutations, mapState } from 'vuex';
import AnsWidget from '@/components/ansWidget/index.vue';

export default {
    name: 'GlobalWidget',
    components: {
        AnsWidget
    },
    computed: {
        ...mapState('app', {
            isWidgetVisible: (state) => state.widget.isVisible,
            showContent: (state) => state.widget.showContent,
            widgetComponent: (state) => state.widget.component,
            componentProps: (state) => state.widget.componentProps,
            onIconClick: (state) => state.widget.onIconClick,
            onClose: (state) => state.widget.onClose,
            widgetConfig: (state) => ({
                position: state.widget.position,
                isMobile: state.widget.isMobile,
                iconProps: state.widget.iconProps,
                showCloseButton: state.widget.showCloseButton,
                showIconToggle: state.widget.showIconToggle,
                styles: state.widget.styles,
                classes: state.widget.classes,
                offset: state.widget.offset,
                draggable: state.widget.draggable
            })
        })
    },
    methods: {
        ...mapMutations('app', ['hideWidget', 'toggleWidgetContent']),
        handleIconClick() {
            this.toggleWidgetContent();

            if (this.onIconClick && typeof this.onIconClick === 'function') {
                this.onIconClick();
            }
        },
        handleClose() {
            console.log('handleClose');
            this.hideWidget();
        },
        handleComponentClose() {
            this.hideWidget();
        }
    }
};
</script>
